export default __webpack_public_path__ + "static/apyke-black-800-cfd0df01d11d964c25efb2c91cfed86c.png";